const escapedRegExp = (str, flags = '') =>
  new RegExp(str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), flags);

const findAllIndices = (string, match, flags = 'i') => {
  const regExp = escapedRegExp(match, (/g/.test(flags) ? flags : `g${flags}`));
  const indices = [];
  let result;
  // eslint-disable-next-line no-cond-assign
  while ((result = regExp.exec(string)) != null) {
    indices.push(result.index);
  }
  return indices;
};

const splitAndInclude = (string, match, flags = 'i') => {
  const indices = findAllIndices(string, match, flags);
  const parts = [];
  let lastIndex = 0;
  indices.forEach((index) => {
    if (index !== 0) parts.push(string.slice(lastIndex, index));
    parts.push(string.slice(index, index + match.length));
    lastIndex = index + match.length;
  });
  if (lastIndex !== string.length) {
    parts.push(string.slice(lastIndex));
  }
  return parts;
};


export default {
  escapedRegExp,
  findAllIndices,
  splitAndInclude,
};
